import 'popper.js'
import Vue from 'vue'
import VueRouterSync from 'vuex-router-sync'
import BootstrapVue from 'bootstrap-vue'
import '@/filters'
import VeeValidate from 'vee-validate'
import VueMce from 'vue-mce'
import App from '@/App.vue'
import { createRouter } from '@/router'
import { createStore } from '@/store'
import * as Components from '@/components'
import '@/styles/main.scss'
import '@/styles/screen.scss'
import Auth from '@/auth'
import VueRouter from 'vue-router'

import 'tinymce/tinymce'
import 'tinymce/themes/modern/theme'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/link'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/code'
import 'tinymce/plugins/image'
import 'tinymce/plugins/table'
import 'tinymce/plugins/hr'

const router = createRouter()
const store = createStore(router)
Vue.config.ignoredElements = [/^ion-/]
Vue.use(VueRouter)
Vue.use(VueMce)
Vue.use(BootstrapVue)
Vue.use(VeeValidate, {
  events: 'blur|input',
  validity: false
})

// sync the router with the vuex store.
// this registers `store.state.route`
VueRouterSync.sync(store, router)

Object.keys(Components).forEach((key) => {
  const component = Components[key]
  Vue.component(component.name, component)
})

const app = new Vue({
  router: router,
  store: store,
  render: (h) => h(App),
  components: {
    App
  }
})

router.onReady(() => {
  const userPromise = new Promise((resolve) => {
    Auth.checkAuth(store, router)
      .then((user) => {
        resolve(user)
      })
      .catch((error) => {
        console.log(error)
        if (error.response && error.response.status === 401) {
          Auth.logout()
        }
        resolve()
      })
  })
  store.commit('SET_USER_PROMISE', { userPromise })
  app.$mount(document.querySelector('#app') ? '#app' : '#body-container')
})
